import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { importJdaBaselineModalDataAtom } from "./atoms";
import { Category } from "@CommonApi/categories";

export const useImportJdaBaselineModal = () => {
  const { openModal } = useModals();
  const setImportJdaBaselineModalData = useSetAtom(importJdaBaselineModalDataAtom);

  const openImportJdaBaselineModal = (category: Category) => {
    setImportJdaBaselineModalData(category);
    openModal("ModalImportJdaBaseline");
  };

  return { openImportJdaBaselineModal };
};
